<template>
  <div class="app-container">
    <navigation title="借阅历史"></navigation>
    <div class="list" v-if="isShow">
      <van-cell v-for="item in list" :title="item.title">
        <template #label>
          <p class="message" v-if="item.author">著者：<span class="message-content">{{ item.author }}</span></p>
          <p class="message" v-if="item.publishHouse">出版社：<span class="message-content">{{ item.publishHouse }}</span></p>
          <p class="message" v-if="item.publishYear">出版年份：<span class="message-content">{{ item.publishYear }}</span></p>
          <p class="message" v-if="item.callNo">索书号：<span class="message-content">{{ item.callNo }}</span></p>
          <p class="message" v-if="item.returnedDate">归还日期：<span class="message-content">{{ item.returnedDate }}</span></p>
        </template>
      </van-cell>
    </div>
    <div class="no-list" v-else>
      <img src="@/assets/img/no-collection.png" alt="">
      <p>您还没有借阅信息</p>
    </div>
    <scroll></scroll>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import {Cell, CellGroup, List, Icon, Checkbox, Toast} from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'history',
  components: {navigation, version, scroll},
  data () {
    return {
      list: [],
      isShow: true
    }
  },
  created () {
    Toast.loading({
      message: '加载中...'
    });
    window.scrollTo(0,0);
    // 获取借阅历史
    this.getList()
  },
  mounted() {
    // this.$nextTick(function(){
    //   Toast.clear()
    // })
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getList () {
      request('post', '/nlc-api/api/nlc/loanHistory').then(res => {
        console.log('借阅历史', res)
        if(res.code===200) {
          this.list = res.data
          this.$nextTick(()=>{
            Toast.clear()
          });
          if(this.list.length === 0) {
            this.isShow = false
          }
        } else {
          this.isShow = false
        }
      }).catch(e => {
        Toast.clear()
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ECF5FD;
  padding-top:.92rem;
}
.list{
  width:6.94rem;
  min-height:12.28rem;
  margin:.16rem .28rem;
  border-radius:8px;
  background:#fff;
}
.van-cell{
  border-radius:8px;
}
.van-cell__title{
  font-size:.3rem;
  color:#444649;
}
>>>.van-cell__label{
  font-size:.28rem;
}
.state{
  font-size:.24rem;
  color:#94979C;
}
.state-return{
  color:#008095;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.message-content{
  position:absolute;
  right:.4rem;
  max-width: 4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.no-list{
  width:6.94rem;
  height:12.28rem;
  background:#fff;
  border-radius:8px;
  margin:.16rem .28rem;
  font-size: .28rem;
  font-family: SourceHanSerifCN-Light;
  color: rgba(51, 51, 51, 0.4);
  text-align:center;
}
.no-list img{
  width:3.27rem;
  height:3.84rem;
  margin-top:3.8rem;
}
</style>



// WEBPACK FOOTER //
// src/view/history/index.vue